import { CssBaseline } from "@mui/material";
import { Header } from "layouts/Header";
import SideBar from "layouts/SideBar";
import { PropsWithChildren, useEffect, useState } from "react";
import { useLocation } from "react-router";

const MainLayout = (props: PropsWithChildren<any>) => {
  // const location = useLocation();
  const [mobileOpen, setMobileOpen] = useState(false);
  // useEffect(() => {
  //   setMobileOpen(false);
  // }, [location]);

  return (
    <div style={{ display: "flex", height: "100%", width: "100%" }}>
      <CssBaseline />
      <SideBar onClose={() => setMobileOpen(false)} open={mobileOpen} />
      <main
        style={{
          flex: 1,
          height: "100%",
          width: "100%",
        }}
      >
        <Header handleDrawerToggle={() => setMobileOpen(true)} />
        <div
          style={{
            flex: 1,
            padding: "8px",
            height: "calc(100vh - 88px)",
            width: "100%",
          }}
        >
          {props.children}
        </div>
      </main>
    </div>
  );
};

export default MainLayout;
